import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { useHistory } from "react-router-dom";
import InputSelect from "../../common/InputSelect";
import LineTypeList from "../../lineTypes/lineTypesComponents/LineTypeList";
import AgentList from "../../agents/agentComponents/AgentList";
import OfficeList from "../../offices/officeComponents/OfficeList";
import BookList from "../../books/bookComponents/BookList";
import WagerLimitsList from "../../wagerLimits/wagerLimitsComponents/WagerLimitsList";
import ProfileList from "../../profiles/profileComponents/ProfileList";
import {
  Button,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import "./PlayerWagering.css";

const useStyles = makeStyles((theme) => ({
  root: { width: 10, height: 10 },
  button: { display: "block", marginTop: theme.spacing(2) },
  formControl: { margin: theme.spacing(1), minWidth: 120 },
}));

const PlayerWagering = (props) => {
  const classes = useStyles();
  const history = useHistory();

  // Usamos estados para las listas (monedas, agrupaciones, etc.)
  const [currency, setCurrencies] = useState();
  const [grouping, setGrouping] = useState([]);
  const [playerRate, setPlayerRate] = useState([]);

  // Cargar todas las opciones en paralelo para mejor rendimiento
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        // Ejecutar las 3 llamadas en paralelo
        const [currencyResponse, playerRateResponse, groupingResponse] = await Promise.all([
          axios.get(process.env.REACT_APP_API2_URL + "/Agent/Currency_GetList"),
          axios.get(process.env.REACT_APP_API2_URL + "/Player/PlayerRate_GetList"),
          axios.get(process.env.REACT_APP_API2_URL + "/Player/Grouping_GetList")
        ]);

        // Procesar Currency
        const currencyInfo = currencyResponse.data.map((v) => ({
          ...v,
          idLineType: v.idCurrency,
          description: v.description,
        }));
        setCurrencies(currencyInfo);

        // Procesar Player Rate
        const rateInfo = playerRateResponse.data.map((v) => ({
          ...v,
          idLineType: v.idPlayerRate,
          description: v.playerRateName,
        }));
        setPlayerRate(rateInfo);

        // Procesar Grouping
        const groupingInfo = groupingResponse.data.map((v) => ({
          ...v,
          idGrouping: v.idGrouping,
          groupName: v.groupName,
        }));
        setGrouping(groupingInfo);
      } catch (error) {
        console.error("Error loading player wagering data:", error);
      }
    };

    fetchAllData();
  }, []);

  // Función centralizada para actualizar el estado del padre (memoizada)
  const handleChange = useCallback((field, value) => {
    props.updatePlayerField(field, value);
  }, [props.updatePlayerField]);

  // Funciones específicas para algunos campos (comboboxes) - memoizadas
  const changeCurrencyID = useCallback((value) => handleChange("idCurrency", value), [handleChange]);
  const changeGroupingID = useCallback((value) => handleChange("idGrouping", value), [handleChange]);
  const changePlayerRateID = useCallback((value) => handleChange("idPlayerRate", value), [handleChange]);
  const setIdBookOnMem = useCallback((value) => handleChange("idBook", value), [handleChange]);
  const setIdLineTypeOnMem = useCallback((value) => handleChange("idLineType", value), [handleChange]);
  const setIdAgentOnMem = useCallback((value) => handleChange("idAgent", value), [handleChange]);
  const setIdOfficeOnMem = useCallback((value) => handleChange("idOffice", value), [handleChange]);
  const setProfileOnMem = useCallback((value) => handleChange("idProfile", value), [handleChange]);
  const setProfileLimitOnMem = useCallback((value) => handleChange("idProfileLimits", value), [handleChange]);

  const handleSave = () => {
    if (!props.Player?.idPlayer) {
      props.InsertPlayer?.(props.Player);
    } else {
      props.Updateplayer?.(props.Player);
    }
  };

  const handleClose = () => history.push("/players");

  const BULK_FIELDS = ["DuplicatedBets", "DuplicatedBetsOnline", "HoldBets"];

  const [indet, setIndet] = React.useState({});

  useEffect(() => {
    if (props.isBulk) {
      const init = {};
      BULK_FIELDS.forEach(f => { init[f] = true; });
      setIndet(init);
    } else {
      setIndet({});
    }
  }, [props.isBulk]);

  const handleCheck = (field) => {
    if (indet?.[field]) {
      setIndet(prev => ({ ...prev, [field]: false }));
    }
  };
  console.log('props player wagering ===>', props.Player)
  const isIndeterminate = (field) => !!(props.isBulk && indet?.[field]);
  if (!props.Player || Object.keys(props.Player).length === 0) {
    return null;
  }
  return (
    <>

      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-2 w-full gap-4">
          <div className="vertical-options">
            <TextField
              size="small"
              type="number"
              label="Credit Limit"
              value={props.Player.creditLimit || ""}
              onChange={(e) => handleChange("creditLimit", e.target.value)}
              variant="outlined"
            />
            <TextField
              size="small"
              type="number"
              label="Temp Credit"
              value={props.Player.tempCredit || ""}
              onChange={(e) => handleChange("tempCredit", e.target.value)}
              variant="outlined"
            />
            <TextField
              size="small"
              type="datetime-local"
              label="Temp Expires"
              value={props.Player.tempCreditExpire || ""}
              onChange={(e) => handleChange("tempCreditExpire", e.target.value)}
              variant="outlined"
            />
            {props.Player.idPlayer !== 0 && (
              <TextField
                size="small"
                type="number"
                label="Soft Limit %"
                value={props.Player.softLimitPercent || ""}
                onChange={(e) =>
                  handleChange("softLimitPercent", e.target.value)
                }
                variant="outlined"
              />
            )}
            <TextField
              size="small"
              type="number"
              label="Settle"
              value={props.Player.settledFigure || ""}
              onChange={(e) => handleChange("settledFigure", e.target.value)}
              variant="outlined"
            />
            <TextField
              size="small"
              type="number"
              label="Chart %"
              value={props.Player.chartPercent || ""}
              onChange={(e) => handleChange("chartPercent", e.target.value)}
              variant="outlined"
            />
            {props.Player.idPlayer !== 0 && (
              <>
                <TextField
                  size="small"
                  type="number"
                  label="Master Chart"
                  value={props.Player.masterChart || ""}
                  onChange={(e) => handleChange("masterChart", e.target.value)}
                  variant="outlined"
                />
                <TextField
                  size="small"
                  type="number"
                  label="Action Pts Max"
                  value={props.Player.maxActionPoints || ""}
                  onChange={(e) =>
                    handleChange("maxActionPoints", e.target.value)
                  }
                  variant="outlined"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={props.Player.allowNegTrans ?? false}
                      indeterminate={isIndeterminate("AllowNegTrans")}
                      onChange={(e) => {
                        handleChange("allowNegTrans", e.target.checked);
                        handleCheck("AllowNegTrans");
                      }}
                    />
                  }
                  label="Allow Negative Transactions"
                />
              </>
            )}
          </div>
          <div className="vertical-options">
            <LineTypeList
              isInput={true}
              initialValue={props.Player.idLineType ?? 0}
              row={props.Player}
              setIdLineTypeOnMem={setIdLineTypeOnMem}
            />
            <InputSelect
                variant="outlined"
                size="small"
                label="Currency"
                data={currency}
                placeholder="Currency"
                setSelectValue={changeCurrencyID}
                startValue={props.Player.idCurrency}
              />
              <OfficeList
                isInput={true}
                initialValue={props.Player.idOffice ?? 0}
                row={props.Player}
                setIdOfficeOnMem={setIdOfficeOnMem}
              />
              <div className="flex flex-row gap-4">
                <InputSelect
                  variant="outlined"
                  size="small"
                  label="Grouping"
                  data={grouping}
                  placeholder="Grouping"
                  setSelectValue={changeGroupingID}
                  startValue={props.Player.idGrouping}
                />
                <Button variant="contained" disabled>
                  Clear
                </Button>
              </div>
              <InputSelect
                variant="outlined"
                size="small"
                label="Player Rating"
                data={playerRate}
                placeholder="PlayerRate"
                setSelectValue={changePlayerRateID}
                startValue={props.Player.idPlayerRate}
              />
              <BookList
                isInput={true}
                initialValue={props.Player.idBook ?? 0}
                row={props.Player}
                setIdBookOnMem={setIdBookOnMem}
              />
              <ProfileList
                isInput={true}
                initialValue={props.Player.idProfile ?? 0}
                row={props.Player}
                setProfileOnMem={setProfileOnMem}
              />
              <WagerLimitsList
                isInput={true}
                initialValue={props.Player.idProfileLimits ?? 0}
                row={props.Player}
                setProfileLimitOnMem={setProfileLimitOnMem}
              />
              <div className="flex flex-row gap-4">
                <AgentList
                  isInput={true}
                  initialValue={props.Player.idAgent ?? 0}
                  row={props.Player}
                  setIdAgentOnMem={setIdAgentOnMem}
                />
                <Button variant="contained" disabled>
                  Clear
                </Button>
              </div>
              <div className="flex flex-row gap-4">
                <TextField
                  size="small"
                  type="text"
                  label="Affiliate"
                  value={props.Player.idAffiliate || ""}
                  disabled
                  onChange={(e) =>
                    handleChange("idAffiliate", e.target.value)
                  }
                  variant="outlined"
                />
                <Button variant="contained" disabled>
                  Clear
                </Button>
              </div>
          </div>
        </div>
        {(props.Player.idPlayer !== 0 || props.isBulk) && (
          <>
            <div className="vertical-options">
              <h3>Local</h3>
              <div className="flex flex-row items-center gap-4">
                <TextField
                  size="small"
                  type="number"
                  label="Max Wager"
                  value={props.Player.maxWager || ""}
                  onChange={(e) => handleChange("maxWager", e.target.value)}
                  variant="outlined"
                />
                <TextField
                  size="small"
                  type="number"
                  label="Min Wager"
                  value={props.Player.minWager || ""}
                  onChange={(e) => handleChange("minWager", e.target.value)}
                  variant="outlined"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={props.Player.duplicatedBets ?? false}
                      indeterminate={isIndeterminate("DuplicatedBets")}
                      onChange={(e) => {
                        handleChange("duplicatedBets", e.target.checked);
                        handleCheck("DuplicatedBets");
                      }
                      }
                      color="primary"
                    />
                  }
                  label="Allow Duplicated Bets"
                />
              </div>
              <TextField
                size="small"
                type="text"
                label="Flag Type"
                value={props.Player.idFlagMessageType || ""}
                disabled
                onChange={(e) =>
                  handleChange("idFlagMessageType", e.target.value)
                }
                variant="outlined"
              />
              <TextField
                size="small"
                type="text"
                label="Flag"
                value={props.Player.flagMessage || ""}
                onChange={(e) => handleChange("flagMessage", e.target.value)}
                variant="outlined"
              />
            </div>
            <div className="vertical-options">
              <h3>Online</h3>
              <div className="flex flex-row items-center gap-4">
                <TextField
                  size="small"
                  type="number"
                  label="Max Wager"
                  value={props.Player.onlineMaxWager || ""}
                  onChange={(e) =>
                    handleChange("onlineMaxWager", e.target.value)
                  }
                  variant="outlined"
                />
                <TextField
                  size="small"
                  type="number"
                  label="Min Wager"
                  value={props.Player.onlineMinWager || ""}
                  onChange={(e) =>
                    handleChange("onlineMinWager", e.target.value)
                  }
                  variant="outlined"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={props.Player.duplicatedBetsOnline ?? false}
                      indeterminate={isIndeterminate("DuplicatedBetsOnline")}
                      onChange={(e) => {
                        handleChange("duplicatedBetsOnline", e.target.checked);
                        handleCheck("DuplicatedBetsOnline")
                      }
                      }
                      color="primary"
                    />
                  }
                  label="Allow Duplicated Bets"
                />
              </div>
              <TextField
                size="small"
                type="text"
                label="Flag"
                value={props.Player.onlineMessage || ""}
                onChange={(e) =>
                  handleChange("onlineMessage", e.target.value)
                }
                variant="outlined"
              />
            </div>
            <div className="vertical-options">
              <h3>Hold Bets</h3>
              <div className="flex flex-row gap-4">
                <TextField
                  size="small"
                  type="number"
                  label="Delay"
                  value={props.Player.holdDelay || ""}
                  onChange={(e) =>
                    handleChange("holdDelay", e.target.value)
                  }
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">secs.</InputAdornment>
                    ),
                  }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={props.Player.holdBets ?? false}
                      indeterminate={isIndeterminate("HoldBets")}
                      onChange={(e) => {
                        handleChange("holdBets", e.target.checked);
                        handleCheck("HoldBets")
                      }
                      }
                      color="primary"
                    />
                  }
                  label="Enabled"
                />
              </div>
            </div>
          </>
        )}
        {props.Player.idPlayer === 0 && !props.isBulk && (
          <div className="flex flex-row gap-4">
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleSave}
            >
              Add
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleClose}
            >
              Close
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default PlayerWagering;




